var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 93,
    viewBox: "0 0 84 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5 46.5V63.9375H10.5V17.4375H28.875V11.625H10.5C9.10761 11.625 7.77226 12.2374 6.78769 13.3274C5.80312 14.4175 5.25 15.8959 5.25 17.4375V63.9375C5.25 65.4791 5.80312 66.9575 6.78769 68.0476C7.77226 69.1376 9.10761 69.75 10.5 69.75H31.5V81.375H21V87.1875H63V81.375H52.5V69.75H73.5C74.8924 69.75 76.2277 69.1376 77.2123 68.0476C78.1969 66.9575 78.75 65.4791 78.75 63.9375V46.5H73.5ZM47.25 81.375H36.75V69.75H47.25V81.375Z",
    fill: "#20DDA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25 52.3125H47.2237C46.658 52.306 46.1093 52.0972 45.6594 51.7174C45.2095 51.3375 44.8825 50.8069 44.7271 50.2046L40.0197 31.9688H28.875V26.1562H42C42.5704 26.1562 43.1253 26.362 43.5807 26.7422C44.0361 27.1225 44.3672 27.6567 44.5239 28.2639L47.3437 39.1882L55.2418 10.77C55.412 10.1795 55.746 9.66351 56.1963 9.29526C56.6466 8.92701 57.1902 8.72528 57.75 8.71875C58.3029 8.70969 58.8437 8.8981 59.2923 9.25606C59.7408 9.61402 60.0733 10.1225 60.2403 10.706L64.8918 26.1562H78.75V31.9688H63C62.449 31.9688 61.912 31.7768 61.4651 31.4202C61.0181 31.0635 60.6839 30.5601 60.5097 29.9815L57.85 21.1465L49.7585 50.2613C49.5933 50.8552 49.2606 51.3748 48.8092 51.744C48.3577 52.1132 47.8113 52.3124 47.25 52.3125Z",
    fill: "#20DDA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealingIcon);
export default __webpack_public_path__ + "static/media/healing-icon.f484c0ad8bbc67e8d8420ce61b409bcd.svg";
export { ForwardRef as ReactComponent };